import { useState, useEffect } from 'react';
import { SellerNoticesPage } from './seller/SellerNoticesPage';
import { DesktopSellerNoticesPage } from './desktop/DesktopSellerNoticesPage';

export function ResponsiveSellerNoticesPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerNoticesPage /> : <DesktopSellerNoticesPage />;
}